import { render } from "./FormFieldLabelOnlyComponent.vue?vue&type=template&id=1ce3620f"
import script from "./FormFieldLabelOnlyComponent.vue?vue&type=script&lang=js"
export * from "./FormFieldLabelOnlyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__